import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';

const parseCSVLine = (line) => {
  const cells = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') { inQuotes = !inQuotes; }
    else if (ch === ',' && !inQuotes) { cells.push(current.trim()); current = ''; }
    else { current += ch; }
  }
  cells.push(current.trim());
  return cells;
};

const FileUploader = ({ onFilesSelected, selectedFiles, onCsvDataLoaded }) => {
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    onFilesSelected(files);
    
    if (files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        const csv = e.target.result;
        const lines = csv.split('\n').filter(line => line.trim());
        const headers = parseCSVLine(lines[0]);
        const data = lines.slice(1).map(line => parseCSVLine(line));
        onCsvDataLoaded(data, headers);
      };
      reader.readAsText(file);
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 2 }}>
      <Box textAlign="center">
        <input
          accept=".csv"
          style={{ display: 'none' }}
          id="csv-file-upload"
          multiple
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="csv-file-upload">
          <Button
            variant="contained"
            component="span"
            startIcon={<CloudUpload />}
            size="large"
          >
            Select CSV Files
          </Button>
        </label>
        
        {selectedFiles.length > 0 && (
          <Box mt={2}>
            <Typography variant="body2" color="textSecondary">
              Selected: {selectedFiles.map(f => f.name).join(', ')}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default FileUploader;